// eslint-disable-next-line import/prefer-default-export
export const setAuthState = authState => {
  return {
    type: 'SET_AUTH_STATE',
    payload: {
      authState,
    },
  };
};
